module.exports = __webpack_public_path__ + "static/media/productos_metal.c0d3b653.jpg";